import React, { useState, useEffect } from 'react';
import {  useHistory } from 'react-router-dom';
import {  FormGroup, Form, Container, Row, Col, Fade, Alert } from 'reactstrap';
import { ButtonLogin,  InputLogin} from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faBookMedical, faMicroscope, faUser,  } from '@fortawesome/free-solid-svg-icons';

import ls from '../../services/localStorage/index';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
/* import ReCAPTCHA from "react-google-recaptcha"; */
import api from '../../services/client/api';
import { validarTelefone,  validarData, validarEmail, validarNome } from '../../utils/formValidations.js';
import moment from 'moment';


const RegisterResidentView = () => {

  const history = useHistory();
  const [name, setName] = useState('');
  const [cep, setCep] = useState('');
  const [logradouro, setLogradouro] = useState('');
  const [bairro, setBairro] = useState('');
  const [estado, setEstado] = useState('');
  const [complemento, setComplemento] = useState('');
  const [cidade, setCidade] = useState('');
  const [numRua, setNumRua] = useState('');
  const [especialidade, setEspecialidade ] = useState('');
  const [genero, setGenero] = useState('');
  const [rg, setRg] = useState('');
  const [cpf, setCpf] = useState('');
  const [nacionalidade, setNacionalidade] = useState('');
  const [instituicaoGraduacao, setInstituicaoGraduacao] = useState('');
  const [anoConclusaoGraduacao, setAnoConclusaoGraduacao] = useState('');
  const [crm, setCrm] = useState('');
  const [statusR3, setStatusR3] = useState('');
  const [instituicaoR3, setInstituicaoR3] = useState('');
  const [anoConclusaoR3, setAnoConclusaoR3] = useState('');
  const [outrosTitulos, setOutrosTitulos] = useState('');
  const [experiencia, setExperiencia] = useState('');
  const [possuiExperiencia, setPossuiExperiencia] = useState('');
  const [declaracao, setDeclaracao] = useState('');
  const [email, setEmail] = useState('');
  const [tel_user, setTelefone] = useState('');
  const [responseAlert, setResponseAlert] = useState('');
  const [dataNasc, setDataNasc] = useState('');
  const [inProgress, setInProgress] = useState(false);
  /* const [recaptchaToken, setRecaptchaToken] = useState(''); */
  const [modal, setModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const toggle = () => setModal(!modal);
const normalizarEspacos = (t) => t.replace(/\s+/g, ' ').trim();

         useEffect(() => {
    const buscarCep = async () => {
      const cepLimpo = cep.replace(/\D/g, '');

      if (cepLimpo.length === 8) {
        try {
          const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
          const data = await response.json();

          if (data.erro) {
     
            return;
          }

          setLogradouro(data.logradouro || '');
          setBairro(data.bairro || '');
          setCidade(data.localidade || '');
          setEstado(data.uf || '');

        } catch (error) {
          console.error("Erro ao buscar CEP:", error);
        }
      }
    };

    buscarCep();
  }, [cep]); // roda sempre que o CEP mudar
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setInProgress(true);
 setEspecialidade("Citopatologia")
  // Normaliza o nome antes de tudo
  const nomeNormalizado = normalizarEspacos(name);
  // Atualiza o state (opcional, mas recomendado)
  setName(nomeNormalizado);

  if (nomeNormalizado === '') {
    setResponseAlert('Por favor, informe o nome completo.');
    setInProgress(false);
    return;
  }

  if (!validarNome(nomeNormalizado)) {
    setResponseAlert('Nome inválido. Por favor, forneça um nome válido.');
    setInProgress(false);
    return;
  }

  if (statusR3 === '') {
    setResponseAlert('Por favor, informe o Status de Residência médica R3.');
    setInProgress(false);
    return;
  }
  if (genero === '') {
    setResponseAlert('Por favor, informe o seu sexo.');
    setInProgress(false);
    return;
  }
  if (experiencia === '') {
    setResponseAlert('Por favor, informe se possui experiência prévia nas áreas de Dermatopatologia e Citopatologia.');
    setInProgress(false);
    return;
  }
  if (especialidade === '') {
    setResponseAlert('Por favor, informe a especialidade que você deseja cursar.');
    setInProgress(false);
    return;
  }


if (dataNasc === '') {
  setResponseAlert('Por favor, informe a data de nascimento.');
  setInProgress(false);
  return;
}

if (!validarData(dataNasc)) {
  setResponseAlert('Data de nascimento inválida. Verifique o formato e tente novamente.');
  setInProgress(false);
  return;
}

if (tel_user === '') {
  setResponseAlert('Por favor, informe o número de telefone.');
  setInProgress(false);
  return;
}

if (!validarTelefone(tel_user.replace(/\D/g, ''))) {
  setResponseAlert('Número de telefone inválido. Verifique e tente novamente.');
  setInProgress(false);
  return;
}

if (email === '') {
  setResponseAlert('Por favor, informe o endereço de e-mail.');
  setInProgress(false);
  return;
}

if (!validarEmail(email)) {
  setResponseAlert('E-mail inválido. Por favor, forneça um endereço de e-mail válido.');
  setInProgress(false);
  return;
}
  const dataNascFormatada = moment(dataNasc, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss[Z]');
const formData = new FormData();

formData.append("Especialidade", especialidade);
formData.append("NomeResidente", name);
formData.append("DtaNascimento", dataNascFormatada);
formData.append("CPF", cpf.replace(/\D/g, ''));
formData.append("RG", rg.replace(/\D/g, ''));
formData.append("Nacionalidade", nacionalidade);
formData.append("CEP", cep.replace(/\D/g, ''));
formData.append("Bairro", bairro);
formData.append("Logradouro", logradouro);
formData.append("NumLogradouro", numRua);
formData.append("ComplementoLogradouro", complemento);
formData.append("Municipio", cidade);
formData.append("Estado", estado);
formData.append("Telefone", "55" + tel_user.replace(/\D/g, ''));
formData.append("Email", email.toLowerCase());
formData.append("InstituicaoGraduacao", instituicaoGraduacao);
formData.append("AnoGraduacao", anoConclusaoGraduacao);
formData.append("CRM", crm);
formData.append("StatusR3", statusR3);
formData.append("AnoR3Conclusao", anoConclusaoR3);
formData.append("InstituicaoR3", instituicaoR3);
formData.append("OutrasEspecialidades", outrosTitulos);
formData.append("Experiencias", experiencia);
formData.append("Genero", genero);

    try {

      const response = await api().user().preRegisterResident(formData);
            if (response.status === 201 && response.output.status === 'success') {
                await ls().set("residentDataToken", response.output.residentDataToken, 60); // expira em 60 minutos
                await ls().set("sessionTokenResident", response.output.sessionTokenResident, 60);
                await ls().set("url", response.output.url, 60);
                
          // Redireciona diretamente para a URL fornecida
            history.replace({
              pathname: '/biometric-alert',
              state: {
                url: response.output.url,
              },
            })
         //window.location.replace(response.output.url);
        }
      
    } catch (error) {
      if(error.message === 'Username already exists'){
          alert("Residente já cadastrado!");
          return
      }
     alert("Informamos que, no momento, o sistema responsável pela biometria facial está temporariamente indisponível devido a uma manutenção programada. Pedimos a gentileza de tentar novamente em breve. Agradecemos a sua compreensão.");
         return
    } finally {
  
        setInProgress(false);
      
    }
    toggle();
  };

  const handleDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');

    if (value.length > 2) {
      value = `${value.slice(0, 2)}/${value.slice(2)}`;
    }
    if (value.length > 5) {
      value = `${value.slice(0, 5)}/${value.slice(5)}`;
    }

    setDataNasc(value);
  };

  const applyCpfMask = (value) => {
    const cleanedValue = value.replace(/\D/g, '');
    const match = cleanedValue.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
    if (match) {
      return `${match[1]}${match[2] ? '.' + match[2] : ''}${match[3] ? '.' + match[3] : ''}${match[4] ? '-' + match[4] : ''}`;
    }

    return value;
  };

  const applyCepMask = (value) => {
  const cleanedValue = value.replace(/\D/g, '');
  const match = cleanedValue.match(/^(\d{0,5})(\d{0,3})$/);

  if (match) {
    return `${match[1]}${match[2] ? '-' + match[2] : ''}`;
  }

  return value;
};

const applyRgMask = (value) => {
  const cleanedValue = value.replace(/\D/g, '');
  const match = cleanedValue.match(/^(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,1})$/);

  if (match) {
    return `${match[1]}${match[2] ? '.' + match[2] : ''}${match[3] ? '.' + match[3] : ''}${match[4] ? '-' + match[4] : ''}`;
  }

  return value;
};

 

   const applyPhoneMask = (value) => {
    const cleanedValue = value.replace(/\D/g, '');
    const match = cleanedValue.match(/^(\d{0,2})(\d{0,5})(\d{0,4})$/);

    if (match) {
      return `${match[1] ? '(' + match[1] : ''}${match[2] ? ') ' + match[2] : ''}${match[3] ? '-' + match[3] : ''}`;
    }

    return value;
  };

  const applyYearMask = (value) => {
  // remove tudo que não for número
  const cleanedValue = value.replace(/\D/g, '');

  // limita a 4 dígitos
  return cleanedValue.slice(0, 4);
};


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit(e);
    }
  };

/* 
  const onChangeCap = (value) => {
    setRecaptchaToken(value);
  }; */
useEffect(() => {
  if (responseAlert) {
    setShowAlert(true); // mostra com fade

    const timeout = setTimeout(() => {
      setShowAlert(false); // começa a esconder com fade
      // depois que sumir, limpa o conteúdo
      setTimeout(() => setResponseAlert(''), 700);
    }, 7000);

    return () => clearTimeout(timeout);
  }
}, [ responseAlert]);

  return (
  <Container>
    <div style={{ marginTop: '20px', textAlign: 'left' }}>
    <b>Laboratório CEDAP - Programa de Residência em {/* Dermatopatologia e */} Citopatologia</b>
    </div>
    <div style={{ marginTop: '10px', marginBottom: '20px',  textAlign: 'left' }}>
     <span ><b>Ano de Ingresso: 2026</b></span>
    </div>

    <Form onSubmit={handleSubmit}>

    
      {/* Especialidade */}
      {/* <Row>
        <Col xs={12}>
          <FormGroup>
            <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
              Selecione a especialidade de Residência Médica R4 que você deseja cursar:<FontAwesomeIcon icon={faMicroscope} />
            </div>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}></span>
            <div style={{ marginLeft: "20px" }}>
              <label>
                <input
                  type="radio"
                  value="Dermatopatologia"
                  checked={especialidade === "Dermatopatologia"}
                  onChange={(e) => setEspecialidade(e.target.value)}
                  required
                /> Dermatopatologia
              </label>
         
              <label>
                <input
                style={{ marginLeft: "20px" }}
                  type="radio"
                  value="Citopatologia"
                  checked={especialidade === "Citopatologia"}
                  onChange={(e) => setEspecialidade(e.target.value)}
                /> Citopatologia
              </label>
            </div>
          </FormGroup>
        </Col>
      </Row> */}

  
      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        1. Dados Pessoais <FontAwesomeIcon icon={faUser} />
      </div>
      <Row>
        <Col md={6}>
          <FormGroup>  <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Nome completo:
              </span>

            <InputLogin
              type="text"
              placeholder="Digite seu nome completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
              maxLength="120"
              required
            />
          </FormGroup>
        </Col>
         <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>
                Data de nascimento:</span>
            <InputLogin
              type="text"
              placeholder="DD/MM/AAAA"
              value={dataNasc}
              onChange={handleDateChange}
              maxLength="10"
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
       
   <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>CPF:</span>
            <InputLogin
              type="text"
              placeholder="Digite seu CPF"
              value={applyCpfMask(cpf)}
              onChange={(e) => setCpf(e.target.value)}
              maxLength="14"
              required
            />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Sexo:</span>
            <div style={{ marginRight: "70px" }}>
              <label>
                <input
                  type="radio"
                  value="M"
                  checked={genero === "M"}
                  onChange={(e) => setGenero(e.target.value)}
                  required
                /> Masculino
              </label>
             
              <label>
                <input style={{ marginLeft: "15px" }}
                  type="radio"
                  value="F"
                  checked={genero === "F"}
                  onChange={(e) => setGenero(e.target.value)}
                /> Feminino
              </label>
             <label>
                <input style={{ marginLeft: "15px" }}
                  type="radio"
                  value="N"
                  checked={genero === "N"}
                  onChange={(e) => setGenero(e.target.value)}
                /> Não Binário
              </label>
              
            </div>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>RG:</span>
            <InputLogin
              type="text"
               placeholder="Digite seu RG"
               value={applyRgMask(rg)}
               maxLength="12"
              onChange={(e) => setRg(e.target.value)}
              required
            />
          </FormGroup>
        </Col>

     
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Nacionalidade:</span>
            <InputLogin
             placeholder="Digite sua nacionalidade"
              type="text"
              value={nacionalidade}
              onChange={(e) => setNacionalidade(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>
      
      <Row>
    <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>CEP:</span>
            <InputLogin
              type="text"
               placeholder="Digite seu CEP"
              value={applyCepMask(cep)}
              onChange={(e) => setCep(e.target.value)}
              maxLength="9"
              required
            />
          </FormGroup>
        </Col>
          <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Bairro:</span>
            <InputLogin
             placeholder="Digite seu bairro"
              type="text"
              value={bairro}
              onChange={(e) => setBairro(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Logradouro:</span>
            <InputLogin
             placeholder="Logradouro"
              type="text"
              value={logradouro}
              onChange={(e) => setLogradouro(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
   <Col md={3}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Número:</span>
            <InputLogin
             placeholder="Nº"
              type="text"
              value={numRua}
              onChange={(e) => setNumRua(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
           <Col md={3}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Complemento*</span>
            <InputLogin
             placeholder="Apto/Bloco"
              type="text"
              value={complemento}
              onChange={(e) => setComplemento(e.target.value)}
            />
          </FormGroup>
        </Col>
      

    
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Cidade:</span>
            <InputLogin
              type="text"
               placeholder="Digite o nome da cidade"
              value={cidade}
              onChange={(e) => setCidade(e.target.value)}
              required
            />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Estado:</span>
            <InputLogin
              type="text"
              placeholder="Digite o nome do estado"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Telefone (celular):</span>
                <InputLogin
                  type="text"
                  placeholder="Digite seu telefone celular"
                  value={applyPhoneMask(tel_user)}
                  onChange={(e) => setTelefone(e.target.value)}
                  onKeyPress={handleKeyPress}
                  maxLength="15"
                  required
                />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>E-mail para contato:</span>
            <InputLogin
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

  
      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        2. Informações Acadêmicas <FontAwesomeIcon icon={faBookMedical} />
      </div>
      <Row>
        <Col md={12}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Instituição de graduação em Medicina:</span>
            <InputLogin
              type="text"
              placeholder="Digite o nome da Instituição"
              value={instituicaoGraduacao}
              onChange={(e) => setInstituicaoGraduacao(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Ano de conclusão do curso:</span>
            <InputLogin
              type="text"
               placeholder="Digite o ano de conclusão"
              value={applyYearMask(anoConclusaoGraduacao)}
              onChange={(e) => setAnoConclusaoGraduacao(e.target.value)}
              maxLength="4"
              required
              
            />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>CRM (ou equivalente):</span>
            <InputLogin
              type="text"
               placeholder="Digite o CRM (ou equivalente)"
              value={crm}
              maxLength="20"
              onChange={(e) => setCrm(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'Left',
              }}>Residência Médica Básica (R3):</span>
            <div style={{ marginRight: "35px" }}>
              <label>
                <input
                  type="radio"
                  value="true"
                  checked={statusR3 === true}
                  onChange={(e) => setStatusR3(e.target.value === "true")}
                />
                Concluída
              </label>
            
              <label>
                 <input style={{ marginLeft: "10px" }}
                  type="radio"
                  value="false"
                  checked={statusR3 === false}
                  onChange={(e) => setStatusR3(e.target.value === "true")}
                />
                Em andamento
              </label>
            </div>
          </FormGroup>
            </Col>
                  <Col md={6}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Ano de conclusão da Residência Médica Básica (se aplicável):</span>
            <InputLogin
              type="text"
              placeholder="Digite o ano de conclusão da Residência (se aplicável)"
              value={applyYearMask(anoConclusaoR3)}
              onChange={(e) => setAnoConclusaoR3(e.target.value)}
              maxLength="4"
              required
            />
          </FormGroup>
        </Col>
      
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Instituição onde realizou ou está realizando a Residência Médica Básica:</span>
            <InputLogin
              type="text"
              value={instituicaoR3}
              onChange={(e) => setInstituicaoR3(e.target.value)}
              required
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <FormGroup>
           <span style={{
                display: 'block',
                marginBottom: '0px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#6c757d',
                textAlign: 'left',
              }}>Outras especializações ou títulos acadêmicos(se houver):</span>
            <textarea
              className="form-control"
              style={{ borderRadius: "10px" }}
              rows={4}
              maxLength={300}
              value={outrosTitulos}
              onChange={(e) => setOutrosTitulos(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>

      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        3.Experiência em Dermatopatologia ou Citopatologia <FontAwesomeIcon icon={faMicroscope} />
      </div>
    <Row>
  <Col md={12}>
    <FormGroup>
      <span style={{
        display: 'block',
        marginLeft: '20px',
        fontWeight: 650,
        fontSize: '15px',
        color: '#6c757d',
        textAlign: 'center',
      }}>
        Possui experiência prévia nas áreas de Dermatopatologia ou Citopatologia?
      </span>

      <div style={{ marginLeft: "20px" }}>
        <label>
          <input
            type="radio"
            value="Sim"
            checked={possuiExperiencia === "Sim"}
            onChange={() => {
              setPossuiExperiencia("Sim");
              setExperiencia(""); // limpa o texto ao marcar sim
            }}
            required
          />{" "}
          Sim
        </label>

        <label style={{ marginLeft: "10px" }}>
          <input
            type="radio"
            value="Não"
            checked={possuiExperiencia === "Não"}
            onChange={() => {
              setPossuiExperiencia("Não");
              setExperiencia("Não"); // atribui "Não" ao campo experiencia
            }}
          />{" "}
          Não
        </label>
      </div>
    </FormGroup>
  </Col>
</Row>
{possuiExperiencia === "Sim" && (
  <Row>
    <Col md={12}>
      <FormGroup>
        <span style={{
          display: 'block',
          marginLeft: '20px',
          fontWeight: 650,
          fontSize: '15px',
          color: '#6c757d',
          textAlign: 'left',
        }}>
          Se sim, descreva brevemente sua experiência:
        </span>

        <textarea
          className="form-control"
          rows={5}
          style={{ borderRadius: "10px" }}
          value={experiencia}
          onChange={(e) => setExperiencia(e.target.value)}
          required
        />
      </FormGroup>
    </Col>
  </Row>
)}
<div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
  4. Documentos a serem apresentados na entrevista{' '}
  <FontAwesomeIcon icon={faAddressCard} />
</div>

<div
  style={{
    marginLeft: '20px',
    marginBottom: '15px',
    color: '#373b3fff',
    fontSize: '15px',
    textAlign: 'left',
  }}
>
  <p style={{ marginBottom: '8px' }}>
    Poderão se inscrever médicos que atendam aos seguintes critérios:
  </p>

  <ol style={{ paddingLeft: '20px' }}>
    <li style={{ marginBottom: '5px' }}>
      Tenham concluído Residência Médica em Patologia credenciada pela CNRM
      até a data da matrícula.
    </li>
    <li style={{ marginBottom: '5px' }}>
      Possuam registro definitivo ou provisório no CRM.
    </li>
    <li style={{ marginBottom: '5px' }}>
      No dia da entrevista, deverão apresentar os seguintes documentos
      comprobatórios:
      <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
        <li>Diploma de graduação em Medicina reconhecido pelo MEC.</li>
        <li>Certificado ou declaração de conclusão de Residência em Patologia.</li>
        <li>Currículo atualizado (preferencialmente Lattes).</li>
        <li>Documento de identidade e CPF.</li>
      </ul>
    </li>
  </ol>

  <p style={{ marginTop: '10px', fontStyle: 'italic' }}>
    * Não é necessário o envio de documentos no ato da inscrição.
  </p>
</div>



      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        5. Taxa de Inscrição <FontAwesomeIcon icon={faAddressCard} />
      </div>
        <p style={{ marginBottom: '8px', fontWeight: 600, color: '#43484dff', }}>
          O valor da taxa de inscrição é de R$ 250,00. O pagamento pode ser realizado através do pix, que será disponibilizado automaticamente após o envio deste formulário.
        </p>
        
      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        6. Instruções Finais
      </div>
      <div
        style={{
          marginLeft: '20px',
          marginBottom: '15px',
          color: '#373b3fff',
          fontSize: '15px',
          textAlign: 'left',
        }}
      >

      <ul style={{ paddingLeft: '20px', marginTop: '5px' }}>
        <li><b>Inscrição:</b> A inscrição será considerada válida somente após o envio completo do formulário e o pagamento da taxa de inscrição.</li>
        <li><b>Prazo de inscrição:</b> As inscrições estarão abertas de <b>05/01/2026</b> até <b>04/02/2025</b>.</li>
        <li><b>Confirmação de inscrição:</b> Após a análise da documentação e confirmação do pagamento, o candidato receberá um e-mail de confirmação de inscrição com mais informações sobre o processo seletivo.</li>
        <li><b>Processo seletivo:</b> O processo seletivo será realizado em três etapas: prova escrita, prova prática e entrevista.</li>
        <li><b>Outras informações:</b> Quaisquer dúvidas sobre o processo seletivo podem ser enviadas para o e-mail <b>residencia4@cedap.com.br.</b></li>
      </ul>
</div>


      <div style={{ marginTop: '20px', marginBottom: '20px', fontWeight: 'bold' }}>
        7. Declaração de Veracidade e Autorização do uso de dados <FontAwesomeIcon icon={faAddressCard} />
      </div>
      <span style={{
                display: 'block',
                marginBottom: '10px',
                marginLeft: '20px',
                fontWeight: 650,
                fontSize: '15px',
                color: '#43484dff',
                textAlign: 'left',
              }}> Declaro, para os devidos fins, que todas as informações prestadas neste formulário são verdadeiras e correspondem à minha realidade. Autorizo o Laboratório CEDAP a utilizar os meus dados pessoais fornecidos neste formulário para fins de contato e processo seletivo, e a verificar a veracidade dos documentos apresentados.
             
      </span>
     

      <Row>
        <Col md={12}>
          <FormGroup>
            <label style={{ marginLeft: "20px", textAlign: 'left', }}>
              <input
                type="checkbox"
                checked={declaracao}
                onChange={(e) => setDeclaracao(e.target.checked)}
                required
              />{" "}
             Autorizo, ainda, a divulgação dos meus dados de inscrição e resultado do processo seletivo, conforme estabelecido nas normas do programa.
            </label>
          </FormGroup>
        </Col>
      </Row>

      
      
                {responseAlert &&(
                     <>
                      {showAlert &&(
                      <Fade in={showAlert} timeout={600}>
                          <Alert style={{ marginTop: '10px' }} color='danger'>{responseAlert}</Alert>
                      </Fade>
                      )}
                  </>
                )}
            <ButtonLogin type="submit" disabled={inProgress}>
            Enviar
            <FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: '10px' }} />
          </ButtonLogin>
             
      </Form>

    </Container>
  );
};

export default RegisterResidentView;
